import { FormHelperText } from '@mui/material';
import { BaseFormHelperTextProps } from './BaseFormHelperText.types';

/**
 * The base MUI `FormHelperText` control to be wrapped off of by other controls.
 *
 * @param classes - {@link BaseFormHelperTextProps.classes classes} description.
 * @param children - {@link BaseFormHelperTextProps.children children} description.
 */
export const BaseFormHelperText = ({
    classes,
    children,
}: BaseFormHelperTextProps) => {
    return (
        <FormHelperText
            classes={{
                ...classes,
            }}
        >
            {children}
        </FormHelperText>
    );
};